<template>
  <div>
    <div class="d-flex align-center">
      <Breadcrumbs class="pa-2" head="Giảng phí"></Breadcrumbs>
      <div class="flex-fill"></div>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Breadcrumbs from '@/components/basic/Breadcrumbs.vue'

import { mapState, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import BaseDialog from '@/components/base/BaseDialog'
import { formatStartDateForAccountSheet, formatDate, transformDateForDatePicker } from '@/helpers'
import DateSelector from '@/components/basic/DateSelector.vue'

export default {
  components: { Breadcrumbs, BaseDialog, DateSelector },
  data() {
    return {
      upsertAccountSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.upsertAccountSheetDialog.isOpen = false
        },
        callback: () => {}
      }
    }
  },
  computed: {
    isListingPage() {
      return !this.$route.params.id
    }
  },
  methods: {
    ...mapActions('accountsheet', ['updateAccountSheet', 'createAccountSheet']),
    transformDateForDatePicker
  }
}
</script>
